module.exports = __webpack_public_path__ + "static/hollon-fdd47f1a12f1669509b94f899ef62060.jpg";